module.exports = __webpack_public_path__ + "static/media/meet-piper-tabletPro-es.833febbc.svg";